import { callApiWithAuthorization } from "../CallApi";

export async function storeAppInMongoDB(email, app) {
    const request = await callApiWithAuthorization(`/api/v0/integrations/copilot-for-devops/store-app-data`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        },
        body: JSON.stringify({
            email,
            app
        })
    });
    const response = await request.json();
    return response;
}

export async function generateDDL(entities, relations) {
    const request = await callApiWithAuthorization(`/api/v0/integrations/copilot-for-devops/generate-ddl`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        },
        body: JSON.stringify({
            entities,
            relations
        })
    });
    const response = await request.json();
    return response;
}

export async function generateSchemaSpecificationPDF(entities, relations) {
    const request = await callApiWithAuthorization(`/api/v0/integrations/copilot-for-devops/generate-schema-specification-pdf`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        },
        body: JSON.stringify({
            entities,
            relations
        })
    });
    const response = await request.blob();
    return response;
}

export async function checkIfUserHasStoredApps(email) {
    const request = await callApiWithAuthorization(`/api/v0/integrations/copilot-for-devops/has-stored-apps?email=${email}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        }
    });
    const response = await request.json();
    return response;
}

export async function createAppFromStoredApp(organizationId, organizationName, email) {
    const request = await callApiWithAuthorization(`/api/v0/integrations/copilot-for-devops/create-app?language=en`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Skip-Authorization": true
        },
        body: JSON.stringify({
            organizationId,
            organizationName,
            email
        })
    });
    const response = await request.json();
    return response;
}